// Configuracion centralizada de dominios publicos (cliente + worker).
// Sustituye dominios hardcodeados para que staging no "se cuelgue" de produccion.
// Los defaults corresponden a produccion (agorax.today).

const ADMIN_URL = process.env.REACT_APP_ADMIN_URL || 'https://admin.agorax.today';
const CLIENTE_DOMAIN = process.env.REACT_APP_CLIENTE_DOMAIN || '.agorax.today';
const LANDING_URL = process.env.REACT_APP_LANDING_URL || 'https://agorax.today';

// Subdominios reservados que NO son slug de empresa (se usan para routing y landing).
const RESERVED_SUBDOMAINS = (
  process.env.REACT_APP_RESERVED_SUBDOMAINS || 'www,agorax,admin,api,dev,staging,preview'
)
  .split(',')
  .map((s) => s.trim().toLowerCase())
  .filter(Boolean);

export const getAdminUrl = () => ADMIN_URL;

export const getLandingUrl = () => LANDING_URL;

// Dominio completo de una empresa (sin protocolo). Ej: mi-empresa.agorax.today
export const empresaDominio = (slug) => `${slug}${CLIENTE_DOMAIN}`;

// URL https de una empresa. Ej: https://mi-empresa.agorax.today
export const empresaUrl = (slug) => `https://${empresaDominio(slug)}`;

export const esSubdominioReservado = (token) => RESERVED_SUBDOMAINS.includes(String(token || '').toLowerCase());
